import apiClient from "../../api/apiClient";
import {
  clearWorkspaceState,
  fetchWorkspacesFailure,
  fetchWorkspacesStart,
  fetchWorkspacesSuccess,
  persistWorkspaceKey,
  resolveCurrentWorkspace,
  setSelectedWorkspaceKey,
} from "../slices/workspaceSlice";

export const fetchWorkspaces = () => async (dispatch, getState) => {
  dispatch(fetchWorkspacesStart());

  try {
    const { data } = await apiClient.get(
      `${process.env.REACT_APP_BASE_URL}/organizations/mine`,
      { withCredentials: true },
    );

    const organizations = Array.isArray(data?.organizations) ? data.organizations : [];
    dispatch(fetchWorkspacesSuccess(organizations));

    const state = getState();
    const resolvedWorkspace = resolveCurrentWorkspace({
      selectedWorkspaceKey: state.workspace.selectedWorkspaceKey,
      user: state.auth.user,
      organizations,
    });

    dispatch(setSelectedWorkspaceKey(resolvedWorkspace.key));
    persistWorkspaceKey(resolvedWorkspace.key);
  } catch (error) {
    dispatch(
      fetchWorkspacesFailure(
        error?.response?.data?.message || error?.message || "Failed to load workspaces.",
      ),
    );
  }
};

export const selectWorkspace = (workspaceKey) => (dispatch) => {
  const nextKey = workspaceKey || "personal";
  persistWorkspaceKey(nextKey);
  dispatch(setSelectedWorkspaceKey(nextKey));
};

export const resetWorkspaces = () => (dispatch) => {
  persistWorkspaceKey("personal");
  dispatch(clearWorkspaceState());
};